import React from "react";
import { motion } from "framer-motion";

const NullBox = () => {
  // Motion variants for left-right movement
  const frameVariants = {
    initial: { x: 0 },
    animate: {
      x: [0, 10, -10, 0], // Smooth left-right movement
      transition: {
        duration: 6,
        repeat: Infinity,
        repeatType: "loop",
      },
    },
  };

  // Shared styles for all frames
  const frameStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "2px solid rgba(156, 163, 175, 0.4)",
    position: "relative",
    "&:hover": {
      borderColor: "transparent",
      borderImage: "linear-gradient(to right, #8018e7, #10b981, #3b82f6) 1",
    },
  };

  // Dynamically create 10 frames
  const createFrames = (count) => {
    let frames = [];
    for (let i = 0; i < count; i++) {
      frames.push(
        <motion.div
          key={i}
          style={{
            ...frameStyle,
            width: `${95 - Math.pow(i, 1.3) * 2}%`, // Gradual reduction with a non-linear decrease
            height: `${95 - Math.pow(i, 1.3) * 2}%`,
          }}
          variants={frameVariants}
          initial="initial"
          animate="animate"
          whileHover={{ borderImage: "linear-gradient(to right, #8018e7, #10b981, #3b82f6) 1" }}
        >
          {/* Add "Select something" only to the innermost frame */}
          {i === count - 1 && (
            <div
              style={{
                fontFamily: "'Press Start 2P', monospace",
                color: "rgba(156, 163, 175, 1)",
                fontSize: "16px",
                textAlign: "center",
              }}
            >
              Select something
            </div>
          )}
        </motion.div>
      );
    }
    return frames;
  };

  return (
    <motion.div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Render 9 nested frames */}
      {createFrames(9).reduceRight((child, parent) =>
        React.cloneElement(parent, {}, child)
      )}
    </motion.div>
  );
};

export default NullBox;
